import { render, staticRenderFns } from "./DescontosModais.vue?vue&type=template&id=ca36c7ce&scoped=true"
import script from "./DescontosModais.vue?vue&type=script&lang=js"
export * from "./DescontosModais.vue?vue&type=script&lang=js"
import style0 from "./DescontosModais.vue?vue&type=style&index=0&id=ca36c7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca36c7ce",
  null
  
)

export default component.exports